import EditorCombinedStepSchema from 'shared/inquiry_template_editor/combined_steps_config.json';
import ComponentFieldDefaults from 'shared/inquiry_template_editor/component_field_defaults.json';
import ComponentSchemaDefaults from 'shared/inquiry_template_editor/component_schema.json';
import EditorComponentSchema from 'shared/inquiry_template_editor/components_config.json';

import {
  EditorCombinedStepSchemaRecord,
  EditorComponentSchemaRecord,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/types';
import { FieldSchema } from 'lib/fields';
import {
  MultiFieldKey,
  UiComponent,
  UiComponentConfig,
  UiComponentConfigToClientDataMap,
  UiComponentConfigType,
  UiFormComponentConfig,
  UiFormMultiFieldComponentConfig,
  UiFormOptionalFieldComponentConfig,
} from 'lib/interfaces/ui-components';

export type ComponentLibrarySupportedType = Extract<
  UiComponentConfigType,
  keyof typeof ComponentSchemaDefaults
>;

export const isSupportedComponentConfigLibraryType = (
  componentConfigType: UiComponentConfigType,
): componentConfigType is ComponentLibrarySupportedType => {
  return componentConfigType in ComponentSchemaDefaults;
};

export type ComponentSchemaValues<
  ConfigType extends ComponentLibrarySupportedType = ComponentLibrarySupportedType,
> = {
  config: Omit<Extract<UiComponentConfig, { type: ConfigType }>, 'name'>;
  preview: Omit<
    Extract<UiComponent, { type: UiComponentConfigToClientDataMap[ConfigType] }>,
    'name'
  >;
};
type ComponentSchema = {
  [ConfigType in ComponentLibrarySupportedType]: ComponentSchemaValues<ConfigType>;
};

type FieldComponentConfigs = UiFormComponentConfig | UiFormOptionalFieldComponentConfig;
type FieldDefaults<
  ConfigType extends FieldComponentConfigs['type'] = FieldComponentConfigs['type'],
> =
  Extract<FieldComponentConfigs, { type: ConfigType }> extends UiFormMultiFieldComponentConfig
    ? {
        [FieldKey in MultiFieldKey<Extract<FieldComponentConfigs, { type: ConfigType }>>]: {
          name: string;
          config: FieldSchema;
        };
      }
    : FieldSchema;
type ComponentFieldDefaults = {
  [ConfigType in FieldComponentConfigs['type']]: FieldDefaults<ConfigType>;
};

export const COMPONENT_SCHEMA: ComponentSchema = ComponentSchemaDefaults as any;
export const COMPONENT_FIELD_DEFAULTS: ComponentFieldDefaults = ComponentFieldDefaults as any;

// @ts-expect-error: typescript can't infer setting types
export const EDITOR_COMPONENTS_SCHEMA: EditorComponentSchemaRecord = EditorComponentSchema;
// @ts-expect-error: typescript can't infer string => translation keys
export const EDITOR_COMBINED_STEPS_SCHEMA: EditorCombinedStepSchemaRecord =
  EditorCombinedStepSchema;
